import Utils from 'utils/Utils';


export default new class Config {


	constructor() {

	}


	init() {
		const deferred = Utils.Deferred();

		this._setConfig();
		this._setEnvVar();

		this._showCreditsLog();


		deferred.resolve();
		return deferred.promise;
	}


	_setConfig() {
		for (const varName in GRH_Config)
			this[varName] = GRH_Config[varName];
	}


	_setEnvVar() {
		this.IS_DEV = this.IS_DEV == 'true';
		this.IS_PREPROD = this.IS_PREPROD == 'true';
		this.IS_PROD = this.IS_PROD == 'true';
	}


	_showCreditsLog() {
		const darkMode = (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
		const styleLog1 = 'padding: 0px; color:' + (darkMode ? '#FFFFFF' : '#000000') + '; line-height:30px; font-size: 18px; font-family: georgia, serif; font-style: italic;';
		const styleLog2 = 'padding: 0px; color:' + (darkMode ? '#FFFFFF' : '#000000') + '; line-height:20px; font-size: 12px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen-Sans", "Ubuntu", "Cantarell", "Helvetica Neue", sans-serif;';

		if (this.CURRENT_LANG === 'fr') {
			console.log('%c\n\nwww.lesanimals.digital\n%cAgence digitale sensiblement différente\n\n', styleLog1, styleLog2);
		} else if (this.CURRENT_LANG === 'en') {
			console.log('%c\n\nwww.lesanimals.digital\n%cSlightly different digital agency\n\n', styleLog1, styleLog2);
		}
	}


}
